import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { getLocation } from "@faire/web/common/globals/getLocation";

export enum ReviewsDisplayViews {
  PageProductLoggedIn = "page-product-logged-in",
  PageProductLoggedOut = "page-product-logged-out",
  PageBrandLoggedIn = "page-brand-logged-in",
  PageBrandLoggedOut = "page-brand-logged-out",
}

export const useReviewsDisplayView = (): ReviewsDisplayViews | "" => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const location = getLocation();

  const pdpMatch = location?.pathname?.startsWith("/product/p");

  if (pdpMatch) {
    return isLoggedInRetailer
      ? ReviewsDisplayViews.PageProductLoggedIn
      : ReviewsDisplayViews.PageProductLoggedOut;
  }

  const brandMatch = location?.pathname?.startsWith("/brand/b");

  if (brandMatch) {
    return isLoggedInRetailer
      ? ReviewsDisplayViews.PageBrandLoggedIn
      : ReviewsDisplayViews.PageBrandLoggedOut;
  }

  return "";
};
